import {Component, Input, OnInit, SecurityContext} from '@angular/core';
import {UntypedFormControl} from '@angular/forms';
import {DynamicIdService} from 'shared/_services/dynamic.id.service';
import {ControlTemplate} from '../_interface/control-template.enum';
import {isControlRequired} from '../functions/check-if-control-required.fn';
import {FormFieldWarnings} from '../../../../journal/src/_interface/form-field-warnings.interface';

@Component({
	selector: 'form-text-input',
	templateUrl: './text-input.component.html',
	styleUrls: ['../../../../../src/assets/scss/custom/_forms.scss']
})
export class TextInputComponent implements OnInit {

	@Input()
	control: UntypedFormControl;

	@Input()
	placeholder: string;

	@Input()
	id: string = this.dynamicIdService.getId('text-input');

	@Input()
	templateFieldId: string;

	@Input()
	label: string;

	@Input()
	template: ControlTemplate = ControlTemplate.inline;

	@Input()
	spellcheck: boolean;

	@Input() set setWarnings(warnings: FormFieldWarnings) {
		this.warnings = warnings;
	}

	@Input() search = false;

	ControlTemplate = ControlTemplate;
	isControlRequired: boolean;
	warnings: FormFieldWarnings;
	securityContext = SecurityContext;

	constructor(private dynamicIdService: DynamicIdService) {
	}

	ngOnInit(): void {
		if (!this.control) throw new Error('Control is required');
		this.isControlRequired = isControlRequired(this.control);
	}

	phraseSelect = ($event: any) => {
		this.control.patchValue((this.control.value || '') + $event.content);
		this.control.markAsDirty();
		this.control.markAsTouched();
	}
}
